import { trackEvent } from 'dibs-tracking';

/**
 * Formats date string to MM-YYYY used by GA.
 */
export function formatDate(dateString?: string): string | undefined {
    if (dateString) {
        const date = new Date(dateString);

        if (!isNaN(date.getTime())) {
            return `${date.getMonth() + 1}-${date.getFullYear()}`;
        }
    }

    return undefined;
}

export const trackFooterNavigationClick = ({
    label,
    additional,
}: {
    label: string;
    additional?: Record<string, string>;
}): void => {
    trackEvent({
        category: 'navigation',
        action: 'footer navigation click',
        label: (label || '').trim().toLowerCase(),
        additional,
    });
};
